"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayValidator = void 0;
const Validator_1 = require("../validator/Validator");
class ArrayValidator extends Validator_1.Validator {
    static isArray(value) {
        return Array.isArray(value);
    }
    static notEmpty(value) {
        return value.length > 0;
    }
    static minLength(value, min) {
        return _a.isArray(value) && value.length >= min;
    }
    static maxLength(value, max) {
        return _a.isArray(value) && value.length <= max;
    }
    static arrayContent(value, contentType) {
        return _a.isArray(value) && value.every(item => typeof item === contentType);
    }
    static arrayObject(value, fieldsValidator) {
        return _a.isArray(value) && value.every(item => fieldsValidator.validate(item).isSuccess);
    }
}
exports.ArrayValidator = ArrayValidator;
_a = ArrayValidator;
ArrayValidator.IS_ARRAY = () => _a.validatorFactory('IS_ARRAY', _a.isArray);
ArrayValidator.NOT_EMPTY = () => _a.validatorFactory('NOT_EMPTY', _a.notEmpty);
ArrayValidator.MIN_LENGTH = (min) => _a.validatorFactory('MIN_LENGTH', value => _a.minLength(value, min));
ArrayValidator.MAX_LENGTH = (max) => _a.validatorFactory('MAX_LENGTH', value => _a.maxLength(value, max));
ArrayValidator.ARRAY_CONTENT = (contentType) => _a.validatorFactory('ARRAY_CONTENT', value => _a.arrayContent(value, contentType));
ArrayValidator.ARRAY_OBJECT = (fieldsValidator) => _a.validatorFactory('ARRAY_OBJECT', value => _a.arrayObject(value, fieldsValidator));
//# sourceMappingURL=ArrayValidator.js.map